import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { HistoricVesselData } from '../../models/vessels/maritime-ais-api';
import type { Vessel, VesselPort } from '../../models/vessels/vessel.model';

export type NormalisedSelectedVessels = {
  byId: Record<string, VesselPort>;
  allIds: VesselPort['vessel_id'][];
};

type VesselDossierStateType = {
  selectedVessels: null | NormalisedSelectedVessels;
  selectedVesselIds: null | string[];
  selectedVesselsData: null | HistoricVesselData[];
};

export const INITAL_VESSEL_DOSSIER_STATE: VesselDossierStateType = {
  selectedVessels: null,
  selectedVesselIds: null,
  selectedVesselsData: null,
};

const VesselDossierSlice = createSlice({
  name: 'vessel-dossier',
  initialState: INITAL_VESSEL_DOSSIER_STATE,
  reducers: {
    setSelectedVesselIds: (state, action: PayloadAction<string[] | null>) => {
      state.selectedVessels = null;
      state.selectedVesselIds = action.payload;
    },
    setSelectedVessels: (state, action: PayloadAction<Vessel[] | null>) => {
      state.selectedVesselIds = null;
      if (action.payload) {
        state.selectedVessels = {
          byId: action.payload.reduce(
            (acc, vessel) => {
              acc[vessel.vessel_id] = vessel;
              return acc;
            },
            {} as Record<string, Vessel>
          ),
          allIds: action.payload.map((vessel) => vessel.vessel_id),
        };
      } else {
        state.selectedVessels = {
          byId: {},
          allIds: [],
        };
      }
    },
    toggleSelectedVessel: (state, action: PayloadAction<Vessel>) => {
      if (state.selectedVessels) {
        const isNewVessel = !state.selectedVessels.allIds.includes(
          action.payload.vessel_id
        );
        if (!isNewVessel) {
          state.selectedVessels.allIds = state.selectedVessels.allIds.filter(
            (id) => id !== action.payload.vessel_id
          );
          delete state.selectedVessels.byId[action.payload.vessel_id];
          if (state.selectedVesselsData) {
            state.selectedVesselsData = state.selectedVesselsData.filter(
              (data) => data.vessel.vessel_id !== action.payload.vessel_id
            );
          }
        } else {
          state.selectedVessels.allIds.push(action.payload.vessel_id);
          state.selectedVessels.byId[action.payload.vessel_id] = action.payload;
        }
      } else {
        state.selectedVessels = {
          byId: {
            [action.payload.vessel_id]: action.payload,
          },
          allIds: [action.payload.vessel_id],
        };
      }
    },
    setSelectedVesselsData: (
      state,
      action: PayloadAction<HistoricVesselData[] | null>
    ) => {
      state.selectedVesselsData = action.payload;
    },
  },
});

export const {
  setSelectedVessels,
  setSelectedVesselIds,
  toggleSelectedVessel,
  setSelectedVesselsData,
} = VesselDossierSlice.actions;

export default VesselDossierSlice.reducer;
